import { translateFn } from 'apps/webcomponents/src/utils/translator.helper';

export const QuarantineActionStatus = {
  ACTION_STATUS_NONE: 0x0000,
  ACTION_STATUS_PENDING_REMOVE: 0x0001,
  ACTION_STATUS_PENDING_SAVE: 0x0010,
  ACTION_STATUS_PENDING_RESTORE: 0x0002,
  ACTION_STATUS_FAILED_REMOVE: 0x0003,
  ACTION_STATUS_FAILED_SAVE: 0x0011,
  ACTION_STATUS_FAILED_RESTORE: 0x0004,
};

export const QuarantineActionStatusToName = {
  [QuarantineActionStatus.ACTION_STATUS_NONE]: 'None',
  [QuarantineActionStatus.ACTION_STATUS_PENDING_REMOVE]: 'Pending remove',
  [QuarantineActionStatus.ACTION_STATUS_PENDING_SAVE]: 'Pending save',
  [QuarantineActionStatus.ACTION_STATUS_PENDING_RESTORE]: 'Pending restore',
  [QuarantineActionStatus.ACTION_STATUS_FAILED_REMOVE]: 'Remove failed',
  [QuarantineActionStatus.ACTION_STATUS_FAILED_SAVE]: 'Save failed',
  [QuarantineActionStatus.ACTION_STATUS_FAILED_RESTORE]: 'Restore failed',
};

export const quarantineActionStatusFilterValues = Object.entries(QuarantineActionStatusToName).map(
  ([value, label]) => ({
    value: Number(value),
    label,
  })
);

export const getTranslatedQuarantineActionStatusToName = () => {
  const translatedQuarantineActionStatusToName = {
    [QuarantineActionStatus.ACTION_STATUS_NONE]: translateFn('None'),
    [QuarantineActionStatus.ACTION_STATUS_PENDING_REMOVE]: translateFn('Pending remove'),
    [QuarantineActionStatus.ACTION_STATUS_PENDING_SAVE]: translateFn('Pending save'),
    [QuarantineActionStatus.ACTION_STATUS_PENDING_RESTORE]: translateFn('Pending restore'),
    [QuarantineActionStatus.ACTION_STATUS_FAILED_REMOVE]: translateFn('Remove failed'),
    [QuarantineActionStatus.ACTION_STATUS_FAILED_SAVE]: translateFn('Save failed'),
    [QuarantineActionStatus.ACTION_STATUS_FAILED_RESTORE]: translateFn('Restore failed'),
  };

  return translatedQuarantineActionStatusToName;
};

export const getTranslatedQuarantineActionStatusFilterValues = () => {
  const translatedQuarantineActionStatusFilterValues = Object.entries(getTranslatedQuarantineActionStatusToName()).map(
    ([value, label]) => ({
      value: Number(value),
      label,
    })
  );

  return translatedQuarantineActionStatusFilterValues;
};
